// import external dependencies
import 'jquery';

if (!global._babelPolyfill) {
  require('babel-polyfill');
}


// Import Leaflet
import 'leaflet';

// Import Slick
import 'slick-carousel/slick/slick.min';

// Import masonry
import 'isotope-layout/dist/isotope.pkgd.min.js';
import 'imagesloaded/imagesloaded.pkgd.min.js';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import postTypeArchiveProjetos from './routes/projetos';
import postTypeArchiveFaqs from './routes/faqs';
import contactos from './routes/contactos';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Projetcts page archive
  postTypeArchiveProjetos,
  // Contacts page
  contactos,
  // FAQS archive
  postTypeArchiveFaqs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js